exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sn-sortable {\r\n    cursor: pointer;\r\n}\r\n\r\n.sn-sortable:hover {\r\n    color: orange;    \r\n}\r\n\r\n.sn-sortable.active {\r\n    color: orange;    \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/common/header-field/header-field.component.css
// module id = ../../../../../src/app/components/common/header-field/header-field.component.css
// module chunks = main